import React, { Component, Suspense, useContext } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import DehazeIcon from "@material-ui/icons/Dehaze";
import LanguageIcon from "@material-ui/icons/Language";
import InputAdornment from "@material-ui/core/InputAdornment";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";

import TextField from "@material-ui/core/TextField";
import "./header.css";
import { Auth, API } from "aws-amplify";
import LogoBlock from "./components/LogoBlock";
import * as AuthAPI from "../../../offline-auth/auth";
import { config } from "../../../config";
import { OffLineAPI } from "../../../offline-auth/api";
import PlayCircleIcon from "@material-ui/icons/PlayCircleFilled"

import {
  LanguageContext,
  roleContext,
  PayloadContext,
  LicenseContext,
} from "../../../libs/context";

import ResponsiveSideNav from "../responsiveSideNav/index";
import { userFullName } from "./../../../libs/utils";
import StarIcon from "@material-ui/icons/Star";
import "../../../containers/ui-styles/avatarcircle/avatarcircle.css";

const _Auth = config.isOffline ? AuthAPI.Auth : Auth;
let _API = config.isOffline ? OffLineAPI : API;

class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownMenu: false,
      mobNav: false,
      mobShade: false,
    };
    this.setWrapperRef = this.setWrapperRef.bind(this);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  componentDidMount() {
    // const user = this.context

    document.addEventListener("mousedown", this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (
      this.wrapperRef &&
      !this.wrapperRef.contains(event.target) &&
      (this.props.active || this.state.dropDownMenu)
    ) {
      this.setState({ dropDownMenu: false });
      if (this.props.handleSideNav) {
        this.props.handleSideNav(false);
      }
    }
  };

  toggleDropDown = () => {
    this.setState({ dropDownMenu: !this.state.dropDownMenu });
  };

  handleLogout = async (event) => {
    try{
	    const selfRemoveRes = await _Auth.removeLoggedSelfUser();
	    console.log("self removes Res", selfRemoveRes);
	    if(selfRemoveRes){
		    await _Auth.signOut();
		    this.props.userHasAuthenticated(false, null);
		   this.props.history.push("/")
	    }
    } catch(e){
	    console.log("error handle", e);
    }
  };

  handleOpenSideNav = () => {
    this.props.handleSideNav(true);
  };
  // handleOpenAffiliateSideNav = () => {
  // 	console.log("hittted ldfksdflsdf");
  // 	this.props.handleSideNav(true);
  // };

  // handleOpenContentSideNav = () => {
  // 	console.log("hittted ldfksdflsdf");
  // 	this.props.handleSideNav(true);
  // };

  // handleOpenPluginSideNav = () => {
  // 	console.log("hittted ldfksdflsdf");
  // 	this.props.handleSideNav(true);
  // };

  handleSlideIn = () => {
    this.setState({ mobNav: true });
    this.setState({ mobShade: true });
  };

  handleSlideOut = () => {
    this.setState({ mobNav: false });
    this.setState({ mobShade: false });
  };
  langselect = (event) => {
    const langValue = event.target.value;
    // console.log("event", langValue, this);
    this.props.setLanguage(langValue);
    this.setState({ value: 4 });
  };

  render() {
    let language = this.context;
    let avatarImg = "/images/icons/default-gray-user-avatar.png";
    // let { userPayload } = this.props;

    // const mediaQuery = useMediaQuery("(min-width:767px)");

    let patt = new RegExp("/admin");
    let showToggleIcon = patt.test(window.location.pathname);

    // let affiliatepage = new RegExp("/referral");
    // let showToggleAffiliateIcon = affiliatepage.test(window.location.pathname);

    // let contentpage = new RegExp("/content");
    // let showToggleContentIcon = contentpage.test(window.location.pathname);

    let pluginpage = new RegExp("/plugin");
    let showTogglePluginIcon = pluginpage.test(window.location.pathname);

    let lang = localStorage.getItem("setLang") || this.props.setLang;
    return (
      <LanguageContext.Consumer>
        {(langContext) => (
          <PayloadContext.Consumer>
            {({ payload }) => (
              <roleContext.Consumer>
                {(role) => (
                  <div className="flexRow header">
                    {/* {showTogglePluginIcon && ( */}
                    <div
                      className="displayOrNot mrgRight"
                      onClick={this.handleSlideIn}
                      ref={(e) => this.setWrapperRef(e)}
                    >
                      <DehazeIcon />
                    </div>
                    {/* )} */}
                    {/************ */}
                    <ResponsiveSideNav
                      mobNav={this.state.mobNav}
                      mobShade={this.state.mobShade}
                      handleSlideOut={this.handleSlideOut}
                      handleLogout={this.handleLogout}
                    />

                    <LogoBlock logo={this.props.webLogo} />
                    <div className='flexIline1 callBtn desDisrNot'>
                      <a className='tollfree flexIline1 alignCntr' href={config.helpCenterUrl} target="_blank">
                        <PlayCircleIcon className='callIcon invertWhite' fontSize='small' />{language.help_Center}
                      </a>
                    </div>
                    <div className="flexAutoRow">
                      <TextField
                        size="small"
                        className="langInput"
                        select
                        value={lang}
                        onChange={this.langselect}
                        name="langselect"
                        variant="outlined"
                        inputProps={{ className: "langInputSelect" }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start" className="nomrg">
                              <LanguageIcon />
                            </InputAdornment>
                          ),
                        }}
                      >
                        {/* <MenuItem value="0">English</MenuItem> */}
                        <MenuItem value="ba">
                          {/* {this.props.language.bangla} */}
                          বাংলা
                        </MenuItem>
                        <MenuItem value="en">
                          {/* {this.props.language.english} */}
                          English
                        </MenuItem>
                        <MenuItem value="fr">
                          {/* {this.props.language.french} */}
                          français
                        </MenuItem>
                        <MenuItem value="gj">
                          {/* {this.props.language.gujarati} */}
                          ગુજરાતી
                        </MenuItem>
                        <MenuItem value="hi">
                          {/* {this.props.language.hindi} */}
                          हिन्दी
                        </MenuItem>
                        <MenuItem value="it">
                          {/* {this.props.language.italian} */}
                          Italiana
                        </MenuItem>
                        <MenuItem value="ka">
                          {/* {this.props.language.kannada} */}
                          ಕನ್ನಡ
                        </MenuItem>
                        <MenuItem value="ml">
                          {/* {this.props.language.malyalam} */}
                          മലയാളം
                        </MenuItem>
                        <MenuItem value="ma">
                          {/* {this.props.language.marathi} */}
                          मराठी
                        </MenuItem>
                        <MenuItem value="pt">
                          {/* {this.props.language.portuguese} */}
                          português
                        </MenuItem>
                        <MenuItem value="es">
                          {/* {this.props.language.spanish} */}
                          Española
                        </MenuItem>
                        <MenuItem value="ta">
                          {/* {this.props.language.tamil} */}
                          தமிழ்
                        </MenuItem>
                        <MenuItem value="te">
                          {/* {this.props.language.telugu} */}
                          తెలుగు
                        </MenuItem>
                        <MenuItem value="ur">
                          {/* {this.props.language.urdu} */}
                          اردو
                        </MenuItem>
                      </TextField>

                      <div
                        className="headerAvatarBlock"
                        onClick={this.toggleDropDown}
                        ref={(e) => this.setWrapperRef(e)}
                      >
                        <Suspense
                          fallback={<div>{language.header_loading}</div>}
                        >
                          <div
                            className="headerAvatarBlock"
                            onClick={this.toggleDropDown}
                            ref={(e) => this.setWrapperRef(e)}
                          >
                            <div className="userName pdng8">
                              {/* <span>{userPayload.name}</span> */}
                              <span className="hideInMobile capitalizeTxt">
                                {userFullName(payload)}
                              </span>
                            </div>
                            <div className="userAvatar">
                              {/* <div className="avatarCircle avatarSM "> */}
                              <div className="badgeBox whiteBadge">
                                <StarIcon
                                  color="secondary"
                                  fontSize="small"
                                  style={{ fontSize: "1.0rem" }}
                                />
                              </div>
                              {/* </div> */}
                              <img
                                // src={
                                // 	value.payload?.profilePic &&
                                // 	value.payload?.profilePic?.url
                                // 		? value.payload?.profilePic?.url
                                // 		: avatarImg
                                // }
                                src={
                                  payload?.profileImage?.url
                                    ? payload?.profileImage?.url
                                    : avatarImg
                                }
                                alt="Profile"
                                loading="lazy"
                              />
                            </div>
                            <Suspense
                              fallback={<div>{language.header_loading}</div>}
                            >
                              <div
                                className={
                                  this.state.dropDownMenu
                                    ? "headerAvaDrpDwn show"
                                    : "headerAvaDrpDwn"
                                }
                              >
                                <LicenseContext.Consumer>
                                  {(licensectx) => (
                                    <ul>
                                      {/* <li className="displayOrNot"><Link to="https://www.peoplelinkvc.fr/tarification-par-salle" className="secondaryTxtColor">{this.props.language.instavc_package_buynowbutton}</Link></li> */}
                                      {/* <li className="displayOrNot">
                                    <Link to="/dashboard">
                                      {language.instavc_myprofile_dashboard}
                                    </Link>
                                  </li> */}
                                      <li>
                                        <Link to="/myprofile?value=profile">
                                          {language.instavc_dashboard_myprofile}
                                        </Link>
                                      </li>
                                      <li>
                                        <Link to="/settings">
                                          {language.instavc_dashboard_settings}
                                        </Link>
                                      </li>
                                      {(payload?.role === "Admin" || payload?.role === "subAdmin") && (
                                        <li>
                                          <Link to="/manage-licenses">
                                            {language.instavc_admin_licenses}
                                          </Link>
                                        </li>
                                      )}
                                      {/* {licensectx && licensectx.license && licensectx.license.length > 0 && <li><Link to="/manage-licenses">{language.instavc_admin_licenses}</Link></li>} */}
                                      {/* <li>
                            <Link to="/plugin">{language.plugins}</Link>
                          </li> */}
                                      {/* {role && role === "Admin" && (
                                    <li>
                                      <Link to="/admin/user-management">
                                        {language.users}
                                      </Link>
                                    </li>
                                  )} */}

                                      {/* <li>
                                    <Link to="/admin/class-management">
                                      {language.classes}
                                    </Link>
                                  </li> */}
                                      {/* <li><Link to="/recordings">Video Recordings</Link></li> */}
                                      {/* {config.isClass && ( */}

                                      {/* )} */}
                                      {false && (
                                        <li>
                                          <Link to="/apidashboard">API's</Link>
                                        </li>
                                      )}
                                      {/* {role == "Admin" && (
                            <li>
                              <Link to="/admin">
                                {language.instavc_dashboard_myadmin}
                              </Link>
                            </li>
                          )} */}
                                      {/* {(this.props.isAffiliate) ? <li><Link to="/referral">{language.instavc_dashboard_affiliate}</Link></li> :
								<li><Link to="/affiliate">{language.become_affiliate}</Link></li>
								} */}
                                      <li>
                                        <span
                                          onClick={this.handleLogout}
                                          className="logout"
                                        >
                                          {language.instavc_dashboard_logout}
                                        </span>
                                      </li>
                                    </ul>
                                  )}
                                </LicenseContext.Consumer>
                              </div>
                            </Suspense>
                          </div>
                        </Suspense>
                      </div>
                    </div>
                  </div>
                )}
              </roleContext.Consumer>
            )}
          </PayloadContext.Consumer>
        )}
      </LanguageContext.Consumer>
    );
  }
}

Header.contextType = LanguageContext;
// Header.contextType = roleContext

export default Header;
